import { validate } from "com";
import { ORDERS_ENDPOINTS } from "./endpoints";
import type { CancelOrderResponse } from "./types";
import { apiPatch } from "../shared";

export async function cancelOrder(orderId: string): Promise<CancelOrderResponse> {
  validate.uuid(orderId, "Order ID");
  return apiPatch<CancelOrderResponse>(ORDERS_ENDPOINTS.CANCEL(orderId));
}

export default cancelOrder;
